import { enqueueSnackbar } from 'notistack';
import { REQUEST_RESPONSE } from './states';
import dayjs from 'dayjs';

export const handleErrors = (errors: any) => {
    if (Array.isArray(errors?.data?.message)) {
        return errors.data.message.forEach((arr: any) => {
            arr.forEach((msg: string) => {
                enqueueSnackbar(msg, {
                    variant: 'error'
                });
            });
        });
    } else {
        return enqueueSnackbar(errors?.data?.message || REQUEST_RESPONSE['error'], {
            variant: 'error'
        });
    }
};

export const downloadFile = ({ blob, name }: any) => {
    const href = URL.createObjectURL(blob);
    const file = document.createElement('a');
    file.href = href;
    file.download = name;
    file.click();
    file.remove();
    URL.revokeObjectURL(href);
};

export const getDate = (date: any) => {
    if (!date) return '';
    const newDate = new Date(date);
    return dayjs(newDate.toISOString()).format('DD/MM/YYYY');
};

export const getDateTime = (date: any) => {
    if (!date) return '';
    const newDate = new Date(date);
    return dayjs(newDate.toISOString()).format('DD/MM/YYYY HH:mm');
};

export const formatText = (text: string) => {
    if (!text) return '';
    return text
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
